import styled from 'styled-components';

export const SummaryCharts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 1000px) {
    flex-direction: row;
    justify-content: space-around;
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
  color: #444444;
  white-space: nowrap;
  font-size: 14px;
`;

export const TableContent = styled.div`
  border: 1px solid #cccccc;
  border-top: none;
  border-bottom: none;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
`;

export const TableRow = styled.div`
  display: flex;
  align-items: center;
`;

const cellStyle = `
  padding: 8px 20px;
  text-align: right;
  &:first-child {
    flex: 1;
    text-align: left;
  }
  &:not(:first-child) {
    flex-basis: 200px;
  }
  &:last-child {
    padding-right: 40px;
  }
`;

export const Cell = styled.div`
  ${cellStyle}
`;

export const ColumnCell = styled.div`
  ${cellStyle}
  font-weight: 600;
`;

export const TableGroup = styled.div`
  background: #ccc;
  font-weight: 600;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;

  & ${Cell} {
    padding: 16px 22px;
  }
`;

export const TableHeader = styled.div`
  ${cellStyle}
  font-weight: bold;
  text-align: left;
`;
